import folderStore from 'owa-folders';
import { getSelectedNode } from 'owa-mail-folder-forest-store';
export default function getSelectedFolder() {
    var selectedNode = getSelectedNode();
    var selectedFolderId = null;
    if (selectedNode.type === 1 /* Persona */) {
        selectedFolderId = selectedNode.searchFolderId;
    }
    else if (selectedNode.type === 5 /* PrivateDistributionList */) {
        selectedFolderId = selectedNode.data
            .searchFolderId;
    }
    else {
        selectedFolderId = selectedNode.id;
    }
    return selectedFolderId == null ? null : folderStore.folderTable.get(selectedFolderId);
}
//# sourceMappingURL=getSelectedFolder.js.map